<template>
 <div class="c-tooltip">
    <button
      type="button"
      aria-expanded="true"
      aria-label="Tooltip"
      :class="['c-tooltip__button', {'active': isActive}]"
      @click.prevent="toggleTooltip"
    >
      <svg class="c-tooltip__svg" aria-hidden="true" focusable="false">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#info-rap"></use>
      </svg>
    </button>
    <transition name="tooltip">
      <div class="c-tooltip__container" v-if="isActive">
        <div class="c-tooltip__inner">
          <h2 v-if="title" class="c-tooltip__title">{{ title }}</h2>
          <button class="c-tooltip__close" @click.prevent="toggleTooltip" aria-label="Close tooltip button">
            <svg class="c-tooltip__svg c-tooltip__svg--close" aria-hidden="true" focusable="false">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#cross-rap"></use>
            </svg>
          </button>
        </div>
        <div class="c-tooltip__summary">
          <slot></slot>
          <img v-if="image" class="c-tooltip__image">
        </div>
      </div>
    </transition>
 </div>
</template>

<script>
export default {
 name: "Tooltip",
 props: {
    isActive: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
 },
 data() {
    return {
      isActive: false
    };
 },
 methods: {
    toggleTooltip() {
      this.isActive = !this.isActive;
      this.$emit("toggleTooltip", this.isActive)
    }
 }
};
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/ToolTip.vue